import { Component, OnInit, ViewChild } from '@angular/core';
import {
  MatPaginator,
  MatTableDataSource,
  PageEvent,
  Sort,
} from '@angular/material';
import { animate, state, style, transition, trigger } from '@angular/animations';

import {
  Errors,
  FileService,
  LocalService,
  ManagerService,
  SellerService,
} from 'src/app/core';
import { sellerApi } from 'src/app/config';
import { PopupMessageService } from 'src/app/shared/message/services/message.service';
import { SegmentedToggleOption } from 'src/app/shared/ui/segmented-toggle/segmented-toggle.component';
import { TabTableConfig } from 'src/app/shared/components/expandable-tab-table/expandable-tab-table.component';

@Component({
  selector: 'app-sales-challenge-claims',
  templateUrl: './sales-challenge-claims.component.html',
  styleUrls: ['./sales-challenge-claims.component.scss'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
})
export class SalesChallengeClaimsComponent implements OnInit {
  @ViewChild(MatPaginator) paginator!: MatPaginator;

  userProfile: any;
  companyClaiming: any = '';
  companyRewardType: any = '';
  disableClaim = false;
  isClaimerAdmin = false;

  filterSearch: any = null;
  eligibleDeal = 'eligible';
  dealFilterOptions: SegmentedToggleOption[] = [
    { label: 'Eligible Deals', value: 'eligible' },
    { label: 'All Deals', value: 'all' },
  ];
  statusFilterOptions: any[] = [
    { id: 'all', name: 'All Status' },
    { id: 'true', name: 'Claimed' },
    { id: 'false', name: 'Unclaimed' },
  ];
  selectedStatusFilter: any = { id: 'all', name: 'All Status' };

  dataSalesList = new MatTableDataSource();
  displayedSalesColumnsList: string[] = [
    'expand', 'name', 'poNumber', 'bookingDate', 'bookingAmount', 'quarter', 'points', 'userName',
  ];
  selectedElementId: any = null;
  queryParamsData: any = {
    pageIndex: 0,
    pageSize: 5,
    sortBy: null,
    sortDirection: null,
    searchText: null,
  };
  totalElements: any = null;
  showLoader = false;
  challengeData = {
    eligibleChallenges: [],
    inEligibleChallenges: [],
  };
  claimsTabConfig: TabTableConfig[] = [];

  sellerDealId: any = '';
  claimNowBtnFlag = true;
  spinnerBtnFlag = false;
  claimEligibleDeal = false;

  claimDisclaimerModalOpen = false;
  claimDisclaimerVariant: 'activationConform' | 'nonEligibledeal' | null = null;
  claimSuccessModalOpen = false;
  claimSuccessData: any = null;
  pendingClaimDealId: any = null;

  errors: Errors = { errors: {} };
  Math = Math;
  dataLoaded = false;

  constructor(
    private sellerService: SellerService,
    private managerService: ManagerService,
    private fileService: FileService,
    private popupMessageService: PopupMessageService
  ) {}

  ngOnInit() {
    this.userProfile = LocalService.get('userProfile');

    if (
      this.userProfile.pvieligible === false ||
      (this.userProfile.companyEligibleChallengesDTO &&
        this.userProfile.companyEligibleChallengesDTO.pvieligible === false)
    ) {
      this.disableClaim = true;
    }

    this.loadCompanyPreferences();
  }

  private loadCompanyPreferences(): void {
    if (!this.userProfile.company || !this.userProfile.company.id) {
      this.dataLoaded = true;
      this.getNewSalesChallengeDataList();
      return;
    }
    this.managerService
      .getCompanyPreferences({ companyId: this.userProfile.company.id })
      .subscribe(
        (data: any) => {
          const preferences = data.companyPreferences.map((item: any) => item.enabled);
          this.isClaimerAdmin = preferences[7];

          const companyRewardTypeSel = preferences[11];
          if (companyRewardTypeSel) {
            this.companyRewardType = 'POINTS';
          } else {
            this.companyRewardType = 'CASH';
          }
          if (preferences[11] === false && preferences[12] === false) {
            this.companyRewardType = 'POINTS';
          }

          const companyClaim = data.companyPreferences.find(
            (item: any) => item.name === 'COMPANY_CLAIMING'
          );
          this.companyClaiming = companyClaim !== undefined ? companyClaim.enabled : false;

          this.dataLoaded = true;
          this.getNewSalesChallengeDataList();
        },
        (err: any) => {
          this.errors = err;
          this.dataLoaded = true;
        }
      );
  }

  open(element: any) {
    if (!element.isExpanded) {
      this.selectedElementId = element.id;
      element.isExpanded = !element.isExpanded;
      this.showLoader = true;
      const reqParam: any = element.id + '?userId=' + this.userProfile.id;
      this.sellerService.getChallengeDetails(reqParam).subscribe(
        (data: any) => {
          this.challengeData = data;
          this.showLoader = false;
          this.computeTabConfig();
        },
        () => {
          this.showLoader = false;
        }
      );
    } else {
      element.isExpanded = !element.isExpanded;
    }
  }

  private computeTabConfig(): void {
    const eligible = this.challengeData.eligibleChallenges || [];
    const ineligible = this.challengeData.inEligibleChallenges || [];
    this.claimsTabConfig = [
      {
        label: 'Eligible',
        icon: 'check_circle',
        iconColor: '#22c55e',
        data: eligible.map((c: any) => ({
          challengeName: c.challengeName,
          id: c.acronym,
          pointsBreakdown:
            this.companyRewardType === 'POINTS'
              ? c.pointsBreakDown
              : (c.pointsBreakDown / 200).toLocaleString('en-US', {
                  style: 'currency',
                  currency: 'USD',
                  maximumFractionDigits: 0,
                }),
        })),
        columns: ['challengeName', 'id', 'pointsBreakdown'],
        columnHeaders: {
          challengeName: 'Challenge Name',
          id: 'Id',
          pointsBreakdown: 'Rewards Breakdown',
        },
        emptyMessage: 'No eligible challenges found.',
      },
      {
        label: 'Ineligible',
        icon: 'info',
        iconColor: '#9ca3af',
        data: ineligible.map((c: any) => ({
          challengeName: c.challengeName,
          id: c.acronym,
          comments: c.comments,
        })),
        columns: ['challengeName', 'id', 'comments'],
        columnHeaders: {
          challengeName: 'Challenge Name',
          id: 'Id',
          comments: 'Comments',
        },
        emptyMessage: 'No ineligible challenges found.',
      },
    ];
  }

  searchDataList(searchValue: string) {
    this.filterSearch = searchValue;
    if (this.paginator) {
      this.paginator.pageIndex = 0;
    }
    this.queryParamsData.pageIndex = 0;
    this.getNewSalesChallengeDataList();
  }

  onDealFilterChange(value: string) {
    this.eligibleDeal = value;
    if (this.paginator) {
      this.paginator.pageIndex = 0;
    }
    this.queryParamsData.pageIndex = 0;
    this.getNewSalesChallengeDataList();
  }

  onStatusFilterChange(selectedStatus: any) {
    this.selectedStatusFilter = selectedStatus;
    if (this.paginator) {
      this.paginator.pageIndex = 0;
    }
    this.queryParamsData.pageIndex = 0;
    this.getNewSalesChallengeDataList();
  }

  private isEligibleDeals(): boolean {
    return this.eligibleDeal === 'eligible';
  }

  getPaginatorData(event: PageEvent) {
    this.queryParamsData.pageIndex = event.pageIndex;
    this.queryParamsData.pageSize = event.pageSize;
    this.getNewSalesChallengeDataList();
  }

  sortData(sortValue: Sort) {
    if (this.paginator) {
      this.paginator.pageIndex = 0;
    }
    this.queryParamsData.pageIndex = 0;
    if (sortValue.active === 'customerName') {
      this.queryParamsData.sortBy = 'CUSTOMER_NAME';
    }
    if (sortValue.active === 'bookingDate') {
      this.queryParamsData.sortBy = 'BOOKING_DATE';
    }
    this.queryParamsData.sortDirection = sortValue.direction.toUpperCase();
    this.getNewSalesChallengeDataList();
  }

  getNewSalesChallengeDataList() {
    let queryParams =
      `page=${this.queryParamsData.pageIndex}` +
      `&size=${this.queryParamsData.pageSize}` +
      `&onlyEligibleDeals=${this.isEligibleDeals()}`;
    if (this.queryParamsData.sortBy) {
      queryParams =
        queryParams +
        `&sortBy=${this.queryParamsData.sortBy}&sortDir=${this.queryParamsData.sortDirection}`;
    }
    if (this.filterSearch) {
      queryParams = queryParams + `&searchText=${this.filterSearch}`;
    }
    if (this.selectedStatusFilter && this.selectedStatusFilter.id && this.selectedStatusFilter.id !== 'all') {
      queryParams = queryParams + `&claimStatus=${this.selectedStatusFilter.id}`;
    }
    this.sellerService
      .getNewSalesChallengeList(this.userProfile.company.id, queryParams)
      .subscribe(
        (data: any) => {
          this.dataSalesList.data = data.content;
          this.totalElements = data.totalElements;
          this.claimNowBtnFlag = true;
        },
        () => {}
      );
  }

  downloadSalesClaimByExcel() {
    const url: string =
      sellerApi.newSalesChallenge +
      '/' +
      this.userProfile.company.id +
      `?page=0&size=100000&onlyEligibleDeals=${this.isEligibleDeals()}&excel=true`;
    const fileName: string =
      'Sales_Challenges_Claims_' + this.userProfile.company.id + '.xlsx';
    this.fileService.excelDownloadFile(url, fileName);
  }

  private geteligibledealsData(dealId: any): Promise<any> {
    return new Promise((resolve) => {
      const reqParam: any = dealId + '?userId=' + this.userProfile.id;
      this.sellerService.getChallengeDetails(reqParam).subscribe(
        (response: any) => {
          if (response) {
            this.spinnerBtnFlag = false;
            if (response.eligibleChallenges.length > 0) {
              this.claimEligibleDeal = true;
            }
          }
          resolve(response);
        },
        () => {
          resolve(null);
        }
      );
    });
  }

  private resolveClaimDisclaimerVariant(): 'activationConform' | 'nonEligibledeal' {
    if (this.claimEligibleDeal) {
      return 'activationConform';
    }
    return 'nonEligibledeal';
  }

  async claimDeal(dealId: any) {
    this.sellerDealId = dealId;
    this.claimNowBtnFlag = false;
    this.spinnerBtnFlag = true;
    await this.geteligibledealsData(dealId);

    this.pendingClaimDealId = dealId;
    this.claimDisclaimerVariant = this.resolveClaimDisclaimerVariant();
    this.claimDisclaimerModalOpen = true;
  }

  onClaimDisclaimerConfirm(): void {
    this.claimDisclaimerModalOpen = false;
    this.claimNowBtnFlag = false;
    this.sellerService.claimDeal(this.pendingClaimDealId).subscribe(
      (data: any) => {
        this.sellerDealId = '';
        this.claimSuccessData = data;
        this.claimSuccessModalOpen = true;
        this.getNewSalesChallengeDataList();
      },
      (err: any) => {
        this.errors = err;
        this.claimNowBtnFlag = true;
        this.claimEligibleDeal = false;
        this.sellerDealId = '';
        if (err.message) {
          this.popupMessageService.showError(err.message, 'error');
        }
        if (err.status === '412 - PRECONDITION_FAILED' || err.status === '409 - CONFLICT') {
          this.popupMessageService.showError(err.msg, 'error');
        }
      }
    );
  }

  closeClaimDisclaimerModal(): void {
    this.claimDisclaimerModalOpen = false;
    this.claimNowBtnFlag = true;
    this.sellerDealId = '';
  }

  closeClaimSuccessModal(): void {
    this.claimSuccessModalOpen = false;
    this.claimSuccessData = null;
  }

  trackByIndex(index: number): number {
    return index;
  }

  getUserInitial(name: string): string {
    if (!name) { return '?'; }
    return name.charAt(0).toUpperCase();
  }

  isUnclaimed(element: any): boolean {
    return !element || !element.claimedUsers || element.claimedUsers.length === 0;
  }

  hasPartialClaim(element: any): boolean {
    return element && element.claimedUsers && element.claimedUsers.length === 1;
  }

  isFullyClaimed(element: any): boolean {
    return element && element.claimedUsers && element.claimedUsers.length >= 2;
  }

  currentUserHasClaimed(element: any): boolean {
    if (!element || !element.claimedUsers || !element.claimedUsers.length) {
      return false;
    }
    return element.claimedUsers.findIndex((u: any) => u.id === this.userProfile.id) !== -1;
  }

  prevPage(): void {
    this.queryParamsData.pageIndex = this.queryParamsData.pageIndex - 1;
    this.getPaginatorData({
      pageIndex: this.queryParamsData.pageIndex,
      pageSize: this.queryParamsData.pageSize,
      length: this.totalElements,
    } as PageEvent);
  }

  nextPage(): void {
    this.queryParamsData.pageIndex = this.queryParamsData.pageIndex + 1;
    this.getPaginatorData({
      pageIndex: this.queryParamsData.pageIndex,
      pageSize: this.queryParamsData.pageSize,
      length: this.totalElements,
    } as PageEvent);
  }

  isPrevDisabled(): boolean {
    return this.queryParamsData.pageIndex === 0;
  }

  isNextDisabled(): boolean {
    return (this.queryParamsData.pageIndex + 1) * this.queryParamsData.pageSize >= this.totalElements;
  }

  getRangeStart(): number {
    return this.queryParamsData.pageIndex * this.queryParamsData.pageSize + 1;
  }

  getRangeEnd(): number {
    return Math.min(
      (this.queryParamsData.pageIndex + 1) * this.queryParamsData.pageSize,
      this.totalElements
    );
  }
}
